module.exports = __webpack_public_path__ + "460adc2b7efb6814cd566a1b09d30303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images/8.jpg
// module id = ./src/components/Carousel/images/8.jpg
// module chunks = 0